import { motion } from "framer-motion";

const links = [
  { label: "MANIFESTO", href: "#manifesto" },
  { label: "MIXES", href: "#mixes" },
  { label: "VIDEOS", href: "#videos" },
  { label: "MERCH", href: "#merch" },
  { label: "EVENTS", href: "#events" },
];

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -64 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-white/15"
      data-testid="navbar"
    >
      <div className="flex items-stretch justify-between h-14">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center px-4 sm:px-6 font-mono-x font-bold tracking-tighter text-sm border-r border-white/15 hover:bg-white hover:text-black transition-colors duration-200"
        >
          ADS<span className="text-[#ff3b1d] ml-1">///</span>
        </a>
        <nav className="hidden md:flex items-stretch" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="flex items-center px-5 font-mono-x text-[11px] tracking-[0.2em] text-white/60 border-l border-white/15 hover:bg-white hover:text-black transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#booking"
            data-testid="nav-book-button"
            className="flex items-center px-6 font-mono-x text-[11px] tracking-[0.2em] font-bold bg-[#ff3b1d] text-black border-l border-white/15 hover:bg-white transition-colors duration-200"
          >
            BOOK NOW
          </a>
        </nav>
        <a
          href="#booking"
          data-testid="nav-book-button-mobile"
          className="md:hidden flex items-center px-5 font-mono-x text-[11px] tracking-[0.2em] font-bold bg-[#ff3b1d] text-black border-l border-white/15"
        >
          BOOK
        </a>
      </div>
    </motion.header>
  );
}
